import { render, staticRenderFns } from "./InputWithLabel.vue?vue&type=template&id=54f3eadc&scoped=true&"
import script from "./InputWithLabel.vue?vue&type=script&lang=js&"
export * from "./InputWithLabel.vue?vue&type=script&lang=js&"
import style0 from "./InputWithLabel.vue?vue&type=style&index=0&id=54f3eadc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f3eadc",
  null
  
)

export default component.exports